export enum ContentLengthOptions {
  ALL = "all",
  SHORT = "short",
  MEDIUM = "medium",
  LONG = "long",
}
